// Input checked state
// Used for radio buttons and checkboxes that are wrapped
// in a label.
// ----------------------------------------------------------------

import $ from 'jquery';

import { donationOtherSumActive } from './donation-form/donation-other-sum-active';

const checkedStateTrigger   = $('.js-checkedStateTrigger');
// const checkedStateTarget    = $('.js-checkedStateTarget');

// On click
$(checkedStateTrigger).on('click customClickTrigger', function() {
    checkedStateActivity($(this)[0]);
});

// On load (or refresh)
// If radio buttons are checked then activate styling accordingly
window.addEventListener('load', function() {
    var getCheckedItems = $('.js-checkedStateTrigger:checked');
    if ($(getCheckedItems).each(function() {
        checkedStateActivity($(this)[0]);
    }));
});

// Handle activity state highlight
function checkedStateActivity(item) {
    $(item).closest('.js-checkedStateTarget').find('label').removeClass('u-bg-yellow');

    if ($(item).is(':checked')) {
        $(item).closest('label').addClass('u-bg-yellow');
        $(item).closest('label').trigger('customClickTrigger');
    }

    // Probably update this so it doesn't run on every checked state click.
    // And so the script contained doesn't also process on every radio click.
    donationOtherSumActive($(item));
}
